// Encoding: UTF-8
$(document).ready(function() {

	// Moodbar - slick
	$(".moodbar-content").slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 6000,
		lazyLoad: 'ondemand',
		arrows: true,
		dots: true,
		mobileFirst: true,  
	});
});